import script from "./DatasetTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetTable.vue?vue&type=script&setup=true&lang=ts"

import "./DatasetTable.vue?vue&type=style&index=0&id=765ef800&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-765ef800"]])

export default __exports__